import { useEffect, useState } from "react";
import { getPricing, type Pricing } from "../api/client";

const FALLBACK: Pricing = { unit_amount: 1900, currency: "usd", display: "$19" };

/** Fetches the live Stripe price once per app load, with a safe fallback. */
export function usePricing(): Pricing {
  const [pricing, setPricing] = useState<Pricing>(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    getPricing()
      .then(p => { if (!cancelled) setPricing(p); })
      .catch(() => { /* keep fallback */ });
    return () => { cancelled = true; };
  }, []);

  return pricing;
}
